"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RegularShape = _interopRequireDefault(require("./RegularShape.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/style/Circle
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 */

/**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */
var CircleStyle =
/** @class */
function (_super) {
  __extends(CircleStyle, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function CircleStyle(opt_options) {
    var options = opt_options ? opt_options : {};
    return _super.call(this, {
      points: Infinity,
      fill: options.fill,
      radius: options.radius,
      stroke: options.stroke,
      scale: options.scale !== undefined ? options.scale : 1,
      rotation: options.rotation !== undefined ? options.rotation : 0,
      rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
      displacement: options.displacement !== undefined ? options.displacement : [0, 0]
    }) || this;
  }
  /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   */


  CircleStyle.prototype.clone = function () {
    var scale = this.getScale();
    var style = new CircleStyle({
      fill: this.getFill() ? this.getFill().clone() : undefined,
      stroke: this.getStroke() ? this.getStroke().clone() : undefined,
      radius: this.getRadius(),
      scale: Array.isArray(scale) ? scale.slice() : scale,
      rotation: this.getRotation(),
      rotateWithView: this.getRotateWithView(),
      displacement: this.getDisplacement().slice()
    });
    style.setOpacity(this.getOpacity());
    return style;
  };
  /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */


  CircleStyle.prototype.setRadius = function (radius) {
    this.radius_ = radius;
    this.render();
  };

  return CircleStyle;
}(_RegularShape["default"]);

var _default = CircleStyle;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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